import pako from 'pako';

const state = {
  socket: null, // 소켓 인스턴스
  updateBuffer: [],     // update_data 임시 저장용
  isEventListLoaded: false, // 전체 리스트 수신 여부
  event: {},
  events: [],
  sports: [],
  leagues: [],
  markets: [],
  outcomes: [],
  market_outcome_relations: [],
  betting_types: []
};

const mutations = {
  SET_SOCKET(state, socket) {
    state.socket = socket;
  },
  SET_GAME_DETAIL(state, { eventId, detail }) {
    state.gameDetails = { ...state.gameDetails, [eventId]: detail };
  },
  // 상세 이벤트
  SET_EVENT(state, event) {
    state.event = event;
  },
  // 전체 이벤트 목록
  SET_EVENTS(state, events) {
    state.events = events;
  },
  SET_SPORTS(state, sports) {
    state.sports = sports;
  },
  SET_LEAGUES(state, leagues) {
    state.leagues = leagues;
  },
  SET_MARKETS(state, markets) {
    state.markets = markets;
  },
  SET_OUTCOMES(state, outcomes) {
    state.outcomes = outcomes;
  },
  SET_MARKET_OUTCOME_RELATIONS(state, relations) {
    state.market_outcome_relations = relations;
  },
  SET_BETTING_TYPES(state, types) {
    state.betting_types = types;
  },
  SET_LIVE_EVENT_LIST(state, liveEventList) {
    state.liveEventList = liveEventList;
  }
};

// type(create/update/delete)에 따라 병합/추가/삭제하는 함수
function mergeByType(prevArr = [], updates = []) {
  const arr = [...prevArr];
  updates.forEach(item => {
    const idx = arr.findIndex(e => e.id === item.id);
    // console.log(updates, idx, 'idx')
    if (item.type === 'update' && idx !== -1) {
      arr[idx] = { ...arr[idx], ...item };
    } else if (item.type === 'create' && idx === -1) {
      arr.push(item);
    } else if (item.type === 'delete' && idx !== -1) {
      arr.splice(idx, 1);
    }
  });
  return arr;
}

function mergeUpdateData(state, decoded) {
  // events 병합
  if (decoded.events && Array.isArray(decoded.events)) {
    state.events = mergeByType(state.events, decoded.events);
  }
  // markets 병합
  if (decoded.markets && Array.isArray(decoded.markets)) {
    state.markets = mergeByType(state.markets, decoded.markets);
  }
  // outcomes 병합
  if (decoded.outcomes && Array.isArray(decoded.outcomes)) {
    state.outcomes = mergeByType(state.outcomes, decoded.outcomes);
  }
  // market_outcome_relations 병합
  if (decoded.market_outcome_relations && Array.isArray(decoded.market_outcome_relations)) {
    state.market_outcome_relations = mergeByType(state.market_outcome_relations, decoded.market_outcome_relations);
  }
  // betting_types 병합 (id 기준, create만 추가)
  if (decoded.betting_types && Array.isArray(decoded.betting_types)) {
    const arr = [...state.betting_types];
    decoded.betting_types.forEach(item => {
      if (!arr.some(e => e.id === item.id)) {
        arr.push(item);
      }
    });
    state.betting_types = arr;
  }
  // offers는 outcomes의 betting_offer_id 기준으로 상태/배당만 갱신
  if (decoded.offers && Array.isArray(decoded.offers)) {
    const outcomes = state.outcomes || [];
    decoded.offers.forEach(offer => {
      const idx = outcomes.findIndex(o => o.betting_offer_id === offer.id);
      if (idx !== -1) {
        const prevOdds = outcomes[idx].betting_offer_odds;
        outcomes[idx] = {
          ...outcomes[idx],
          betting_offer_status: offer.status,
          betting_offer_odds: offer.odds,
          prev_odds: prevOdds // 이전 값을 저장
        };
      }
    });
    state.outcomes = outcomes;
  }
}

const actions = {
  connectSocket({ commit, state }) {
    const randomStr = Math.random().toString(36).substring(2, 10);
    const socket = new WebSocket(`wss://ajsdfoljwqpjfpqowjefpjdpfowqepfwej.org/ws/events/${randomStr}`);
    commit('SET_SOCKET', socket);
    socket.onmessage = (msg) => {
      const data = msg.data;
      let decoded = null;
      if (typeof data === 'string') {
        try {
          const compressed = Uint8Array.from(atob(data), c => c.charCodeAt(0));
          const decompressed = pako.inflate(compressed, { to: 'string' });
          decoded = JSON.parse(decompressed);
        } catch (e) {
          console.log('압축 해제 실패:', e);
        }
      }
      if (!decoded) return;
      // 상세
      if (decoded.method === 'event_detail') {
        console.log(decoded.data, 'event_detail')
        commit('SET_EVENT', decoded.data.event || {});
        commit('SET_MARKETS', decoded.data.markets || []);
        commit('SET_OUTCOMES', decoded.data.outcomes || []);
        commit('SET_MARKET_OUTCOME_RELATIONS', decoded.data.market_outcome_relations || []);
        commit('SET_BETTING_TYPES', decoded.data.betting_types || []);
        state.isEventListLoaded = true;
        // 버퍼에 쌓인 update_data를 모두 반영
        state.updateBuffer.forEach(update => {
          mergeUpdateData(state, update.data);
        });
        state.updateBuffer = [];
      }
      // 전체 리스트
      if (decoded.method === 'events' && decoded.success) {
        console.log(decoded.data, 'events')
        commit('SET_EVENTS', decoded.data.events || []);
        commit('SET_SPORTS', decoded.data.sports || []);
        commit('SET_LEAGUES', decoded.data.leagues || []);
        commit('SET_MARKETS', decoded.data.markets || []);
        commit('SET_OUTCOMES', decoded.data.outcomes || []);
        commit('SET_MARKET_OUTCOME_RELATIONS', decoded.data.market_outcome_relations || []);
        commit('SET_BETTING_TYPES', decoded.data.betting_types || []);
        state.isEventListLoaded = true;
        // 버퍼에 쌓인 update_data를 모두 반영
        state.updateBuffer.forEach(update => {
          mergeUpdateData(state, update.data);
        });
        state.updateBuffer = [];
      }
      // 라이브 리스트
      if (decoded.method === 'live_events' && decoded.success) {
        console.log(decoded.data, 'live_events')
        commit('SET_EVENTS', decoded.data.events || []);
        commit('SET_SPORTS', decoded.data.sports || []);
        commit('SET_LEAGUES', decoded.data.leagues || []);
        commit('SET_MARKETS', decoded.data.markets || []);
        commit('SET_OUTCOMES', decoded.data.outcomes || []);
        commit('SET_MARKET_OUTCOME_RELATIONS', decoded.data.market_outcome_relations || []);
        commit('SET_BETTING_TYPES', decoded.data.betting_types || []);

        state.isEventListLoaded = true;
        // 버퍼에 쌓인 update_data를 모두 반영
        state.updateBuffer.forEach(update => {
          mergeUpdateData(state, update.data);
        });
        state.updateBuffer = [];
      }
      // 실시간 업데이트
      if (decoded.method === 'update_data') {
        if (!state.isEventListLoaded) {
          state.updateBuffer.push(decoded);
        } else {
          mergeUpdateData(state, decoded.data);
        }
      }
    };
  },
  fetchGameDetail({ state }, params) {
    if (state.socket && state.socket.readyState === 1) {
      state.socket.send(JSON.stringify({
        method: 'event_detail',
        params
      }));
    }
  },
  fetchEvents({ state }, params) {
    if (state.socket && state.socket.readyState === 1) {
      state.socket.send(JSON.stringify({
        method: 'events',
        params
      }));
    }
  },
  fetchLiveEventList({ state }, params) {
    if (state.socket && state.socket.readyState === 1) {
      state.socket.send(JSON.stringify({
        method: 'live_events',
        params
      }));
    }
  },
  disconnectSocket({ state, commit }) {
    if (state.socket) {
      state.socket.close();
      commit('SET_SOCKET', null);
    }
  }
};

const getters = {
  getEvent: (state) => state.event,
  getEvents: (state) => state.events,
  getSports: (state) => state.sports,
  getLeagues: (state) => state.leagues,
  getMarkets: (state) => state.markets,
  getOutcomes: (state) => state.outcomes,
  getMarketOutcomeRelations: (state) => state.market_outcome_relations,
  getBettingTypes: (state) => state.betting_types,
  getLiveEventList: (state) => state.liveEventList
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}; 